import { Accordion, createAccordion } from '@vfde-brix/ws10/accordion';
import { AppContainerId, HtmlId } from '../enum';
import { createComponentById } from '@vfde-brix/ws10/core';
import { trackAccordion, TrackingUIType } from '@vfde-sails/tracking';
import { JarvisTvProduct } from '@vfde-sails/availability';
import accordionUtils from '../util/component/accordion.utils';
import { AdditionalPageOptions } from '../interface';
import { debugInfo } from '@vfde-sails/utils';

/**
 * Create Brix Accordion component.
 * @param {HtmlId} id - ID of the accordion element.
 * @param {TrackingUIType} trackType - type of the tracking data to be sent
 * @returns {Accordion | null} component or null if element with given id is not found
 */
export const mountAccordion = (id: HtmlId, trackType: TrackingUIType) =>
    createComponentById(createAccordion, id, {
        onClick: (props) => {
            if (props.optOpen) {
                trackAccordion(props.stdHeadline, trackType);
            }
        },
    });

/**
 * Closes all items inside an accordion
 * @param {Accordion} comp - accordion to update
 */
export const closeAccordion = (comp: Accordion) => {
    const { items } = comp.getProperties();

    for (const item of items) {
        item.optOpen = false;
    }

    comp.update({ items });
};

export const updateFootnoteAccordion = (
    comp: Accordion | null,
    cmsProps: AdditionalPageOptions,
    tvConnect?: JarvisTvProduct,
    tvConnectBv?: JarvisTvProduct,
) => {
    if (!comp) {
        return;
    }

    const props = comp.getProperties();
    const item = props.items.find(i => i.stdId === AppContainerId.TV_CONNECT_FOOTNOTE);

    if (!item) {
        debugInfo('Unable to update TV Connect footnote');

        return;
    }

    item.optHidden = !tvConnect && !tvConnectBv;
    item.containerAnyComponent = accordionUtils.getTvConnectContent(
        item.containerAnyComponent,
        cmsProps,
        tvConnect,
        tvConnectBv,
    );

    comp.update(props);
};
